import * as yup from "yup";

/** Same pattern as legacy react-material-ui-form-validator regexp. */
export const INTERNATIONAL_PHONE_REGEX =
  /^(([+][(]?[0-9]{1,3}[)]?)([(]?[0-9]{1,4}[)]?))\s*[)]?[-\s.]?[(]?[0-9]{1,3}[)]?([-\s.]?[0-9]{3})([-\s.]?[0-9]{3,4})$/;

export const EMAIL_INVALID = "Tarkista sähköpostiosoitteen muoto";

export const PHONE_INVALID_INTL =
  "Puhelinnumeron on oltava kansainvälisessä muodossa +3585012345";

export function companyContactEmailSchema() {
  return yup.string().required("Pakollinen kenttä").email(EMAIL_INVALID);
}

export function companyContactPhoneSchema() {
  return yup
    .string()
    .required("Pakollinen kenttä")
    .matches(INTERNATIONAL_PHONE_REGEX, PHONE_INVALID_INTL);
}

/** Full company contacts block — use with `.validateSync` before save */
export function companyContactsSchema() {
  return yup.object({
    contact_email: companyContactEmailSchema(),
    contact_phone: companyContactPhoneSchema(),
  });
}

/** Driver / register: phone may be empty; if set, must match intl pattern */
export function driverOptionalPhoneSchema() {
  return yup
    .mixed()
    .test(
      "intl-if-present",
      PHONE_INVALID_INTL,
      (v) =>
        v == null ||
        v === "" ||
        INTERNATIONAL_PHONE_REGEX.test(String(v).trim()),
    );
}

export function driverInviteEmailSchema() {
  return yup
    .string()
    .nullable()
    .trim()
    .required("Pakollinen kenttä")
    .email(EMAIL_INVALID);
}

export function driverInviteEmail2Schema(primaryEmail) {
  const a = (primaryEmail || "").trim().toLowerCase();
  return yup
    .string()
    .nullable()
    .trim()
    .required("Pakollinen kenttä")
    .email(EMAIL_INVALID)
    .test(
      "match-primary",
      "Sähköpostit eivät täsmää",
      (v) => (v || "").trim().toLowerCase() === a,
    );
}

export function adminInviteEmailSchema() {
  return yup
    .string()
    .nullable()
    .trim()
    .required("Pakollinen kenttä")
    .email(EMAIL_INVALID);
}

/**
 * Validates driver email pair + optional phone before submit (Driver edit / invite).
 * @param {{ id?: unknown, email?: string, email2?: string, phone?: string }} values
 * @param {{ fields?: string[] }} [options]
 */
export function validateDriverSubsetForSubmit(values, { fields } = {}) {
  driverOptionalPhoneSchema().validateSync(values?.phone ?? "");
  const includeEmail = !fields || fields.includes("email");
  if (includeEmail && !values?.id) {
    driverInviteEmailSchema().validateSync(values?.email ?? "");
    driverInviteEmail2Schema(values?.email).validateSync(values?.email2 ?? "");
  }
}
